import { Component, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { User } from '../shared/models/user.model'
import { UserRepositoryService } from '../services/user-repository.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AppConstants } from '../app.constants';
import { SnackBarService } from '../services/snack-bar.service';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized-user.component.html',
  styleUrls: ['./unauthorized-user.component.scss']
})
export class UnauthorizedUserComponent implements OnInit {
  version: string;
  message: string;
  versionDate: string;
  user: User = null;
  accessRequestForm: UntypedFormGroup;

  constructor(private router: Router,
    private userRepository: UserRepositoryService,
    private snackBService: SnackBarService,    
    private fb: UntypedFormBuilder
  ) {
  }
  ngOnInit() {
    this.accessRequestForm = this.fb.group({
      businessJustification: this.fb.control('', [Validators.minLength(3)]),
    });
  }
  getErrorMessage() {
    
  }
  submitAccessRequest() {
    this.userRepository.getRequestAccess(this.accessRequestForm.get('businessJustification')?.value)
      .subscribe((result: any) => {
        if (result) {
          this.snackBService.showSuccess(AppConstants.accessRequestSuccess);
          this.accessRequestForm.reset({businessJustification: ''});
        }
        else {
          this.snackBService.showError(AppConstants.accessRequestFailure);
        }
      },
        err => {
          this.snackBService.showError(AppConstants.accessRequestFailure);
        });
  }
}

